import React from "react";
import { ShoppingBag, Eye, Sparkles } from "lucide-react";
import { useCart } from "../../context/CartContext";

export default function ProductCard({ product, onSelect }) {
  const { addToCart, loading } = useCart();

  const handleQuickAdd = (e) => {
    e.stopPropagation();
    addToCart(product.product_id, 1);
  };

  return (
    <div
      onClick={() => onSelect(product)}
      data-testid={`product-card-${product.product_id}`}
      className="group relative rounded-2xl bg-[#121214] border border-white/10 overflow-hidden flex flex-col justify-between transition-all duration-300 hover:-translate-y-1 hover:border-[#FF8C69]/50 hover:shadow-xl cursor-pointer"
    >
      {/* Image Container */}
      <div className="relative aspect-[4/5] w-full overflow-hidden bg-[#18181B]">
        <img
          src={product.main_media_url}
          alt={product.name}
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />

        {/* Badges */}
        <div className="absolute top-3 left-3 flex flex-col gap-1.5">
          {product.is_featured && (
            <span
              data-testid={`badge-featured-${product.product_id}`}
              className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[#121214]/90 text-[10px] font-bold text-[#FF8C69] border border-white/10 backdrop-blur-md"
            >
              <Sparkles className="w-3 h-3 text-[#FF8C69]" />
              <span>Destaque</span>
            </span>
          )}
          {product.stock_available <= 5 && product.stock_available > 0 && (
            <span
              data-testid={`badge-low-stock-${product.product_id}`}
              className="px-2.5 py-1 rounded-full bg-[#18181B]/90 text-[10px] font-semibold text-amber-400 border border-white/10 backdrop-blur-md"
            >
              Restam {product.stock_available} un.
            </span>
          )}
        </div>

        {/* Hover Quick Action */}
        <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-3 p-4">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onSelect(product);
            }}
            data-testid={`btn-view-detail-${product.product_id}`}
            className="p-3 rounded-xl bg-[#18181B] text-white hover:text-[#FF8C69] border border-white/10 shadow-lg hover:scale-105 transition-all"
            title="Ver detalhes"
          >
            <Eye className="w-5 h-5" />
          </button>
          <button
            onClick={handleQuickAdd}
            disabled={product.stock_available === 0 || loading}
            data-testid={`btn-quick-add-${product.product_id}`}
            className="p-3 rounded-xl bg-[#FF8C69] text-[#0A0A0B] shadow-lg hover:scale-105 transition-all disabled:opacity-50 font-bold"
            title="Adicionar ao carrinho"
          >
            <ShoppingBag className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="p-5 flex-1 flex flex-col justify-between space-y-3">
        <div>
          <h3 className="font-heading text-base font-bold text-white line-clamp-1 group-hover:text-[#FF8C69] transition-colors">
            {product.name}
          </h3>
          <p className="text-xs text-[#A1A1AA] line-clamp-2 mt-1 leading-relaxed">
            {product.short_description}
          </p>
        </div>

        <div className="pt-3 border-t border-white/10 flex items-center justify-between">
          <div>
            {product.formatted_compare_at_price && (
              <span className="block text-[11px] line-through text-[#A1A1AA]/60">
                {product.formatted_compare_at_price}
              </span>
            )}
            <span
              data-testid={`product-price-${product.product_id}`}
              className="font-heading text-lg font-bold text-[#FF8C69]"
            >
              {product.formatted_price}
            </span>
          </div>

          <button
            onClick={handleQuickAdd}
            disabled={product.stock_available === 0}
            data-testid={`btn-buy-card-${product.product_id}`}
            className="px-4 py-2 rounded-xl bg-[#FF8C69] hover:bg-[#FFA285] text-[#0A0A0B] text-xs font-bold transition-all disabled:opacity-40"
          >
            {product.stock_available === 0 ? "Esgotado" : "Comprar"}
          </button>
        </div>
      </div>
    </div>
  );
}
